import React from "react";
import Button from "../../../Components/commonButton/commonButton";
import TextField from "../../../Components/textField/textField";
import TimeTextField from "../../../Components/timeTextField/TimeTextField";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import { setCheckValue } from "../../../services/Functions";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css";
import { Checkbox } from "../../../Components/Checkbox/checkbox";
import { Col } from "react-bootstrap";
import { Checkboxcontainer } from "../../../Components/Checkboxcontainer/Chechboxcontainer";

export default class AddReasonView extends React.Component {
  state = {
    show: false,
    reason: "",
    id: null,
    message: "",
    reload: false,
    andon: false,
    code: "",
    ftq_count: false,
    planned_time: false,
    planned_stop: false,
    all_days: false,
    duration: "",
    block_machine: false,
    notification: false,
    notification_type: "success",
    notification_message: "",
  };

  sendData = () => {
    const {
      reason,
      andon,
      planned_time,
      code,
      duration,
      ftq_count,
      planned_stop,
      block_machine,
      all_days,
    } = this.state;
    if (
      reason !== "" &&
      reason !== null &&
      code !== "" &&
      code !== null &&
      ((this.state.planned_stop == true &&
        this.state.planned_time != "00:00:00" &&
        this.state.planned_time != "" &&
        this.state.planned_time != null) ||
        this.state.planned_stop == false)
    ) {
      const nowDateTime = new Date().toISOString();
      const nowDate = nowDateTime.split("T")[0];
      const targetDuration = new Date(nowDate + duration);
      Api.post("/reasons-stop/", {
        description: reason,
        code: code,
        tracking: andon,
        ftq_count: ftq_count,
        planned_time: planned_time,
        planned_stop: planned_stop,
        block_machine: block_machine,
        all_days: all_days,
      })
        .then(() => {
          this.setState({
            notification: true,
            notification_message: "Motivo cadastrado com sucesso!",
          });
          setTimeout(() => {
            return window.location.reload();
          }, 2000);
        })
        .catch((err) => {
          if (err.response.status === 400)
            return this.setState({
              message: "" + err.response.data.message,
              show: true,
            });
        });
    } else {
      return this.setState({
        message: "Necessário preencher todos os campos.",
        show: true,
      });
    }
  };

  callbackfunction = () => {
    this.setState({ show: false });
  };
  callBackReason = (child) => {
    this.setState({ reason: child });
  };
  callBackCode = (value) => {
    this.setState({ code: value });
  };
  stopTimeCallback = (value) => {
    this.setState({ planned_time: value });
  };

  render() {
    const checkboxConfigs = [
      { key: "andon", label: "Andon" },
      { key: "ftq_count", label: "Setup/FTQ" },
      { key: "block_machine", label: "Bloquear Máquina" },
    ];

    let {
      show,
      message,
      reload,
      planned_stop,
      notification,
      notification_message,
      notification_type,
    } = this.state;
    return (
      <div className="box">
        {notification == true ? (
          <>
            <Notification
              message={notification_message}
              type={notification_type}
            ></Notification>
            <Loading></Loading>
          </>
        ) : (
          <></>
        )}
        {show ? (
          <Alert
            show={show}
            message={message}
            parentCallback={this.callbackfunction}
            reload={reload}
          />
        ) : null}
        <form className="input_fields_add_reason form">
          <h4>Adicionar Motivo</h4>
          <div className="inputs">
            <div className="tf1AddReason element">
              <TextField
                section={true}
                focus={true}
                title="Código"
                max={4}
                parentCallback={this.callBackCode}
                value={this.state.code}
                validationType="int"
              />
            </div>
            <div className="tf2AddReason element">
              <TextField
                title="Descrição"
                max={45}
                parentCallback={this.callBackReason}
                value={this.state.reason}
                validationType="varchar"
              />
            </div>
            <Checkboxcontainer label="Tipos de Parada" icon="info" size>
              {checkboxConfigs.map(({ key, label }) => (
                <Col xs="12" sm="6"className="pe-0">
                  <Checkbox
                    key={key} 
                    id={key}
                    label={label}
                    checked={this.state[key]}
                    setIsActive={() =>
                      this.setState({ [key]: !this.state[key] })
                    }
                    disabled={this.state.planned_stop}
                  />
                </Col>
              ))}
              <Col xs="12" sm="6">
                <Checkbox
                  id="planned_stop"
                  label="Parada Programada"
                  checked={this.state.planned_stop}
                  setIsActive={() =>
                    this.setState(
                      { planned_stop: !this.state.planned_stop },
                      () => {
                        if (this.state.planned_stop) {
                          document.getElementById("time-texfield")?.focus();
                        }
                      }
                    )
                  }
                />
              </Col>
            </Checkboxcontainer>

            <div className="checkboxs">
              
            </div>

            {this.state.planned_stop && (
              <div className="tf3AddReason element">
                <TimeTextField
                  id={"time-texfield"}
                  title="Tempo de parada"
                  hideInput={false}
                  parentCallback={this.stopTimeCallback}
                  seconds={true}
                  disabled={false}
                />
              </div>
            )}

            {this.state.planned_stop && (
              <div className="checkboxs">
                <Checkbox
                  id="all_days"
                  label="Ocorre em todos os dias, em todos os turnos."
                  checked={this.state.all_days}
                  setIsActive={() =>
                    this.setState({ all_days: !this.state.all_days })
                  }
                />
              </div>
            )}
          </div>
          <div className="btnAddReason submitButton">
            <Button
              title="Adicionar"
              icon="add"
              type
              parentCallback={this.sendData}
            />
          </div>
        </form>
      </div>
    );
  }
}
